import React, { useEffect, useState } from "react";
import { fetchAppsCollections } from "../../api/GlobalApi";
import { Link } from "react-router-dom";

function AppCollection() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getCollections = async () => {
      try {
        const data = await fetchAppsCollections();
        setCollections(data);
      } catch (error) {
        console.error("Error fetching collections:", error);
      } finally {
        setLoading(false);
      }
    };

    getCollections();
  }, []);

  const parseRating = (r) => {
    if (r === null || r === undefined || r === "") return 0;
    const n = typeof r === "number" ? r : Number(String(r).replace(",", "."));
    if (!Number.isFinite(n)) return 0;
    return Math.max(0, Math.min(5, n));
  };

  const renderStars = (rawRating) => {
    const rating = parseRating(rawRating);
    const totalStars = 5;
    const fullStars = Math.floor(rating);
    const halfStar = rating - fullStars >= 0.5 && fullStars < totalStars;
    const stars = [];

    for (let i = 0; i < totalStars; i++) {
      if (i < fullStars) stars.push(<span className="stars" key={i}>★</span>);
      else if (i === fullStars && halfStar) stars.push(<span className="stars" key={i}>⯪</span>);
      else stars.push(<span className="stars" key={i}>☆</span>);
    }

    return <span>{stars}</span>;
  };

  // if (loading) return <p>Loading collections...</p>;
  // if (collections.length === 0) return <p>No collections found.</p>;

  return (
    <div>
      {!loading && (
        collections.map((collection) => (
          <section className="section" key={collection.id}>
            <div className="section-header">
              <h2 className="section-title">{collection.title}</h2>
              <Link to={`/collection/${collection.slug}`} className="see-more">See More</Link>
            </div>

            {collection.apps && collection.apps.length > 0 ? (
              <div className="horizontal-scroll">
                {collection.apps.slice(0, 24).map((app) => {
                  const ratingNum = parseRating(app.rating);
                  return (
                    <Link
                      to={`/app/details/${app.slug}`}
                      className="game-card horizontal-card"
                      key={app.id}
                      style={{ textDecoration: "none" }}
                    >
                      <div
                        className="game-image"
                        style={{
                          backgroundImage: `url(${app.feature_graphic_url || app.icon_url})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }}
                      >
                        <div
                          className="game-icon"
                          style={{
                            backgroundImage: `url(${app.icon_url})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        ></div>
                      </div>

                      <div className="game-info">
                        <div className="game-title">{app.name}</div>
                        <div className="game-developer">{app.developer}</div>
                        <div className="game-rating">
                          {renderStars(ratingNum)}
                          <span className="rating-text">{ratingNum.toFixed(1)}</span>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            ) : (
              <p>No apps in this collection.</p>
            )}
          </section>
        ))
      )}
    </div>
  );

}

export default AppCollection;
